import {times} from 'lodash';
import classnames from 'classnames';
import styles from './styles.module.scss';
import React from 'react';

export const Loading = () => (
  <div className="p-24">
    {times(6, (number) => (
      <div className={classnames('shared-shimmer-text full', styles.loadingRow)} key={number} />
    ))}
  </div>
);
